/**
 * Wrapper for $q, that makes it useable as constructor for legacy ng1.0 code
 * (v6)
 */
export type IPromiseConstructor = string;

export const PromiseConstructorProvider = {
  provide: 'PromiseConstructor',
  deps: ['$q'],
  useFactory: ($q: ng.IQService) => {
    return function (resolver) {
      if (!angular.isFunction(resolver)) {
        throw Error(`Expected resolverFn, got '{resolver}'`);
      }

      const deferred = $q.defer();

      function resolveFn(value) {
        deferred.resolve(value);
      }

      function rejectFn(reason) {
        deferred.reject(reason);
      }

      resolver(resolveFn, rejectFn);

      return deferred.promise;
    };
  },
};
